import {Component} from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import {customerGetters} from '../../stores/customer-store'
import {Customer, Plan, Account} from '../../types'
import { PlanActions } from '../../actions/plan-actions'
import { SubscriptionActions } from '../../actions/subscription-actions'
import { CustomerActions } from '../../actions/customer-actions'
import { AnalyticsActions } from '../../actions/analytics-actions'
import {userGetters} from '../../stores/user-store'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'nc-plan-page-v1',
  template: `
    <div class="inner-detail-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <plan-form *ngIf="readyForForm()" [newCustomer]="true" [plans]="plans" [customer]="customer" [account]="account" [adminImpersonating]="adminImpersonating" (onCreate)="next()"></plan-form>
            <div *ngIf="!readyForForm()" class="loader">Loading...</div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class NcPlanPageV1 extends BaseComponent {
  uiState: any;
  customer: Customer;
  account: Account;
  plans: Plan[];
  customerId: number;
  plansLoaded: boolean = false;
  adminImpersonating: boolean = false;

  constructor( private planActions: PlanActions,
               private route: ActivatedRoute,
               private customerActions: CustomerActions,
               private router: Router,
               private subscriptionActions: SubscriptionActions,
               private analyticsActions: AnalyticsActions,
               private titleService: Title
  ) {
    super()
  }

  ngOnInit(): void {
    this.titleService.setTitle('Sign Up - Plan')
    const routeObs = this.route.params.subscribe(params => {
      this.clearRouteObservers()

      this.customerId = +params['customerId']
      this.customerActions.loadCustomer(this.customerId)
      // Load Subscription - to look at previous subscription for plan-form prepopulation
      this.subscriptionActions.loadSubscription(this.customerId)

      // Fetch the customer and observe changes
      const custObs = NuclearObservable.from<Customer>(customerGetters.customer(this.customerId), { toJS: true }).subscribe(c => {
        this.customer = c
        if (this.customer && this.customer.multipass) {
          this.router.navigate(['../', 'multipass-plan'], { relativeTo: this.route })
        }
      })
      this.routeObservers.push(custObs)
    })

    this.planActions.loadPlans().then(() => {
      // Fetch the plans and observe changes
      this.plansLoaded = true
    })
    const accountObs = NuclearObservable.from<Account>(customerGetters.account, { toJS: true }).subscribe(a => this.account = a)
    const plansObs = NuclearObservable.from<Plan[]>(customerGetters.plans, { toJS: true }).subscribe(ps => this.plans = ps)
    const uiObs = NuclearObservable.from<Object>(userGetters.uiState, { toJS: true }).subscribe(ui => this.uiState = ui)
    const userObs = NuclearObservable.from<Object>(userGetters.user, { toJS: true }).subscribe(user => this.adminImpersonating = user && user['adminImpersonating'])
    this.observers.push(routeObs, accountObs, plansObs, uiObs)
  }

  next(): void {
    this.analyticsActions.selectedPlan()
    if (this.adminImpersonating) {
      let redirect_to = '/admins/home'
      if (this.account) { redirect_to = `/accounts/${this.account.id}` }
      window.location.assign(`/switch_back?flash=Customer has been invited to complete sign up!&redirect_to=${redirect_to}`)
    } else if (this.account && this.account.agency) {
      this.customerActions.loadCustomer(this.customer.id)
      this.router.navigate(['/account', 'signup', 'activation'])
    } else {
      this.router.navigate(['../', 'payment'], { relativeTo: this.route })
    }
  }

  readyForForm(): boolean {
    return this.plansLoaded && !!this.customer
  }
}
